import { apiClient } from "../../base/ApiClient";


export const getCarePlanById = async (formID, clientID) => {
  const res = await apiClient.get(`/careplan/api/forms/${formID}/`, {
    params: {
      client: clientID,
    },
  });
  return res.data;
};

export const getActiveCarePlans = async (params = {}) => {
  const res = await apiClient.get(`/careplan/api/assigned-careplans/`, { params });
  return res.data;
};

export const getCarePlans = async (params = {}) => {
  const res = await apiClient.get(`/careplan/careplans/`, { params });
  return res.data;
};

export const activateCarePlan = async (payload) => {
  const res = await apiClient.post(`/careplan/api/assigned-careplans/`, payload);
  return res.data;
};

export const submitForm = async ({ id, method, ...payload }) => {
  if (method === "update" && id) {
    return apiClient.put(`/careplan/api/submission/${id}/`, payload);
  }
  return apiClient.post(`/careplan/api/submission/`, payload);
};

export const fetchForm = async (formId) => {
  const res = await apiClient.get(`/careplan/api/forms/${formId}/`);
  return res.data;
};

export const updateForm = async (id, payload) => {
  const res = await apiClient.patch(`/careplan/api/forms/${id}/`, payload);
  return res.data;
};